import { useEffect, useState } from "react";

/** Bumps a tick counter on an interval so relative timestamps stay fresh without per-row timers. */
export function useRelativeTimeTicker(intervalMs = 30_000): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((value) => value + 1), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return tick;
}
